import React, { useEffect, useState } from "react";
import Text from "antd/lib/typography/Text";
import { Button, Image, Progress } from "antd";
import StackedBarHappiness from "../../components/StackedBarHappiness";
import StackedBarChart from "../../components/StackedBar";
import styles from "../../styles/dashboard.module.scss";
import moment from "moment";
import { authSVC } from "../../services";
import { useB2BContext } from "../../context/ContextB2B";

function IndexBarChartCustom() {
  const [tapIndex3, setTapIndex3] = useState<number>(0);
  const { getUserByID } = useB2BContext();
  const [departmentLevelWellness, setdepartmentLevelWellness] = useState<any[]>(
    []
  );
  const [yearlyDepartmentIndexes, setYearlyDepartmentIndexes] = useState<any>();

  useEffect(() => {
    console.log(tapIndex3, "tapIndex3");
    if (tapIndex3 === 0) {
      FetchDataOnTap("wellness");
    } else {
      FetchDataOnTap("happiness");
    }
  }, [tapIndex3]);

  const FetchDataOnTap = (type: any) => {
    authSVC
      .yearlyDepartmentIndexes({
        reportFor: type,
      })
      .then((res: any) => {
        setYearlyDepartmentIndexes(res?.data?.data);
        console.log(res.data.data, "yearlyDepartmentIndexes");
      })
      .catch((err: any) => {
        //message.error(err.response?.data?.error);
      });
  };

  return (
    <div className={styles.white_bg_wrapper}>
      <div className={styles.info_title}>
        <div className={styles.title_grp}>
          <Text
            style={{
              color: tapIndex3 === 0 ? "" : "#2E3191",
              opacity: tapIndex3 === 0 ? "" : "0.3",
            }}
            className={styles.title}
            onClick={() => setTapIndex3(0)}
          >
            Wellness Index
          </Text>
          <Text
            style={{
              color: tapIndex3 === 1 ? "" : "#2E3191",
              opacity: tapIndex3 === 1 ? "" : "0.3",
            }}
            className={styles.title}
            onClick={() => setTapIndex3(1)}
          >
            Happiness Index
          </Text>
        </div>
      </div>
      <div className={styles.title_grp1} style={{ marginBottom: "16px" }}>
        <Image
          className={styles.img}
          src="/img/new/download_icon.svg"
          preview={false}
        />
        <Text className={styles.subtitle1}>
          {yearlyDepartmentIndexes?.percentage || 0}% from last month
        </Text>
      </div>
      <div className={styles.graph}>
        {yearlyDepartmentIndexes?.series.length === 0 ? (
          <div className="no_data_yet">
            <img src="/img/User_empty.png" alt="" width="56" height="52" />
            <p>No data yet</p>
          </div>
        ) : (
          // <StackedBarHappiness chartData={departmentLevelWellness} />
          <StackedBarHappiness chartData={yearlyDepartmentIndexes} />
        )}
      </div>
    </div>
  );
}

export default IndexBarChartCustom;